// Owner preview (owner, 2026-09-24: "make these visible as coming soon for all
// other than me and we use me as the proofing for deployment"). A feature
// behind this is REAL for Tomer — signed in as the owner and not viewing as
// someone else — and shows "Coming soon" to everyone else until he approves it.
import { session } from './session';

export function ownerPreview(): boolean {
  const me = session.value.me;
  return me?.role === 'OWNER' && !me.viewingAs;
}

/** nvRecruiter (owner, 2026-09-28: "Can you make this available to Candace
 * also please?"; opened to managers 2026-09-29 with the new-application email
 * — a manager is emailed about each new application in their clinic and must
 * be able to open it). Owner, director and managers — and the owner viewing
 * as a clinic sees exactly what that clinic's manager sees (owner,
 * 2026-09-30: viewing as a manager still showed "Coming soon"). My Mail / My
 * Calendar stay on ownerPreview() above. */
export function recruitingPreview(): boolean {
  const me = session.value.me;
  return me?.role === 'OWNER' || me?.role === 'DIRECTOR' || me?.role === 'MANAGER';
}
